/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {TertiaryButton} from '../../components/buttons/TertiaryButton';

// defines the cancel button prop type definitions ...
export interface CancelButtonProps {
  onCancel: any;
  clearForm?: Function;
  disabled?: boolean;
};

/**
 * @CancelButton
 *
 * The CancelButton provides generalized DLS Cancel Button which is typically used
 * within the various Entity Editors.
 *
 * ```typescript
 *
 *    import {CancelButton} from '@ion/dls/src/components/buttons/';
 *
 *    <CancelButton onCancel={onCancel} clearForm={clearForm} disabled={loading} />
 *
 * ```
 *
 * @param {Function} onCancel callback which is invoked when the user clicks cancel.
 * @param {boolean}  clearForm Optional callback which will be invoked when the user
 *                   clicks cancel.
 * @param {boolean}  disabled When true, the button will be disabled.
 */
export const CancelButton = ({clearForm, onCancel, disabled = false}: CancelButtonProps
) => (
  <TertiaryButton onClick={function(e) {
    clearForm?.();
    onCancel(e);
  }} disabled={disabled}>
    {translate('common:editors.shared.cancel')}
  </TertiaryButton>
);

export default CancelButton;
